import React from 'react';
import {withRouter} from "react-router-dom";
import {Button, Container, Header, List} from "semantic-ui-react";
import {CustomContainer} from '../../custom-common';
import {S3Image} from "../../base";
import Footer from "../../footer";
import STRATEGIC_PARTNER from "../../../constants/strategicPartners";
import IMAGE from "../../../constants/images";

const NewClaimSuccess = ({location: {claimNumber}, history}) => {

    const handleButtonClick = () => {
        history.replace("/claims");
    };

    return (
        <>
            <div className="member-main-container">
                <Container textAlign="center">
                    <CustomContainer padded="very" compact textAlign="center" style={{margin: '4em auto 1em auto', width: '460px'}}>
                        <S3Image {...IMAGE.CHECK_CIRCLE_OUTLINE_80PX}/>
                        <Header as="h3">Thanks for filing your claim</Header>
                        <p>Your claim <b>{!!claimNumber ? `(${claimNumber})` : null}</b> will be reviewed by the {STRATEGIC_PARTNER.LABEL} team within 24 hours.</p>
                        <CustomContainer basic textAlign="left">
                            <div className="blueHeader">Next steps:</div>
                            <List ordered relaxed={"very"}>
                                <List.Item className="smaller">If your claim is approved, we’ll pay it in less than 72 hours.</List.Item>
                                <List.Item className="smaller">Otherwise, our team will be in touch within 24 hours.</List.Item>
                            </List>
                        </CustomContainer>
                        <Button primary onClick={handleButtonClick}>All done</Button>
                    </CustomContainer>
                </Container>
            </div>
            <Footer hasToDisplayCarrierDisclaimer/>
        </>
    );
};

export default withRouter(NewClaimSuccess);
